import './App.css';
import { useState } from 'react';
import { faHouse, faTruck, faCog } from '@fortawesome/free-solid-svg-icons'
import NavBar from './sections/NavBar/NavBar.js';
import LogIn from './sections/Login/Login.js';
import Shipments from './shipments/Shipments.js';

export default function App() {
  const [user, setUser] = useState(null);
  const [shipments, setShipments] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const pages = [
    {text:"Dashboard", index: 0, icon: faHouse},
    {text:"Shipments", index: 1, icon: faTruck},
    {text:"Settings", index: 2, icon: faCog}
  ]
  const pageChangeCallback = (index) => {
    setPageIndex(index)
  }
  const setUserCallback = (newUser)=>{
    setUser(newUser);
  }

  if(user ===null){
    return (
      <LogIn setUserCallback={setUserCallback} />
    )
  }else{
    return(
      <div className={"page-wrapper"}>
          <NavBar pageIndex={pageIndex} pages={pages} pageChangeCallback={pageChangeCallback} setUserCallback={setUserCallback} />
          <div className="content-wrapper">
            {JSON.stringify(user)}
            {pageIndex == 0 ? <h1>Page 0</h1> : ""}
            {pageIndex == 1 ? <Shipments /> : ""}
            {pageIndex == 2 ? <h1>Page 0</h1> : ""}
          </div>
      </div>
    )
  }
}
